import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store/store';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Start MSW in development for API mocking
if (process.env.NODE_ENV === 'development') {
  // Use require to keep conditional import
  const { worker } = require('./mocks/browser');
  // Wrap start in a catch to avoid uncaught ServiceWorker registration errors
  worker.start().catch((err) => {
    console.warn('[MSW] Failed to start the Service Worker:', err);
    console.warn('[MSW] If this is a "unsupported MIME type (text/html)" error, ensure `public/mockServiceWorker.js` exists and is the MSW-generated script.');
    console.warn('[MSW] Run `npx msw init public/ --save` to generate it, or disable MSW startup in development.');
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
